import { useMemo } from 'react';
import { useMatches } from 'react-router';
import { z } from 'zod';

const handlerSchema = z.object({
  closedByDefault: z.boolean().optional(),
});

export function useSidebarIsCloseByDefault() {
  const matches = useMatches();

  const closedByDefault = useMemo(() => {
    let defaultVal = false;
    for (const match of matches) {
      const parse = handlerSchema.safeParse(match.handle);
      if (!parse.success) {
        continue;
      }

      const closedByDefaultMatch = parse.data.closedByDefault;
      if (closedByDefaultMatch !== undefined) {
        defaultVal = closedByDefaultMatch;
      }
    }
    return defaultVal;
  }, [matches]);

  return closedByDefault;
}
